import { createFileRoute } from '@tanstack/react-router'
import { ProfilDesa } from '../../../../components/ProfilDesa'

export const Route = createFileRoute('/desa/$slug/dashboard/profil-desa')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <ProfilDesa desaId={desaId} />
  },
})
